import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/admin/kpi-record/`;

const getAdminKpiRecords = async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    return await axios.get(API_URL + (queryString ? `?${queryString}` : ''));
};

const getAdminKpiRecord = async (id) => {
    return await axios.get(API_URL + id);
};

const addAdminKpiRecord = async (formData) => {
    return await axios.post(API_URL, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};

const editAdminKpiRecord = async (id, formData) => {
    return await axios.put(API_URL + id, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};

const deleteAdminKpiRecord = async (id) => {
    return await axios.delete(API_URL + id);
};

const getAdminPointsSummary = async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    return await axios.get(`${BACKEND_URL}/api/admin/kpi-points-summary${queryString ? `?${queryString}` : ''}`);
};

const generateMonthlySummary = async (month, year, maxBonus) => {
    return await axios.post(`${BACKEND_URL}/api/admin/kpi-generate-summary`, { month, year, maxBonus });
};

const getMonthlySummaries = async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    return await axios.get(`${BACKEND_URL}/api/admin/kpi-monthly-summaries${queryString ? `?${queryString}` : ''}`);
};

const updateMonthlySummaryBonus = async (summaryId, maxBonus) => {
    return await axios.put(`${BACKEND_URL}/api/admin/kpi-monthly-summary/${summaryId}/bonus`, { maxBonus });
};

// Set run totals by hand. Marks the row so generating the month skips it.
const setMonthlySummaryManual = async (summaryId, runTotals) => {
    return await axios.put(`${BACKEND_URL}/api/admin/kpi-monthly-summary/${summaryId}/manual`, runTotals);
};

// Recompute from source data and drop any manual edit — also the way back to automatic.
const recalculateMonthlySummary = async (summaryId) => {
    return await axios.post(`${BACKEND_URL}/api/admin/kpi-monthly-summary/${summaryId}/recalculate`);
};

// Record a whole run as transferred. Omit adminIds to mark everyone who is owed.
// paidAt is the settle date — the day the money actually moves, which may be
// earlier than the nominal pay date for an advance payment.
const markRunPaid = async ({ month, year, run, adminIds, paidAt }) => {
    return await axios.post(`${BACKEND_URL}/api/admin/kpi-monthly-summary/mark-paid`, { month, year, run, adminIds, paidAt });
};

const unmarkRunPaid = async (summaryId, run) => {
    return await axios.delete(`${BACKEND_URL}/api/admin/kpi-monthly-summary/${summaryId}/paid`, { data: { run } });
};

// "Pay per run" report: who to pay, how much, into which account.
const getPayrollReport = async (month, year) => {
    return await axios.get(`${BACKEND_URL}/api/admin/payroll-report?month=${month}&year=${year}`);
};

// Opens the ใบสำคัญจ่าย for one payment in a new tab.
const openVoucherPdf = async ({ summaryId, run }) => {
    const response = await axios.get(`${BACKEND_URL}/api/admin/payment-voucher/pdf`, {
        params: { summaryId, run },
        responseType: 'blob',
    });
    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
    window.open(url, '_blank');
    // Revoked late so the new tab has time to load the blob.
    setTimeout(() => window.URL.revokeObjectURL(url), 60000);
};

// Tenure milestones due for confirmation (+1 leave day, +1000 position allowance).
// Scoped to a payroll month: a milestone reached in September first applies to
// October, so it surfaces when October is being paid.
const getTenureMilestones = async (month, year) => {
    return await axios.get(`${BACKEND_URL}/api/admin/tenure-milestones?month=${month}&year=${year}`);
};

// apply: true grants the increase; false records it as already given, pay unchanged.
// Sent explicitly — the backend refuses to guess which was meant.
const resolveTenureMilestone = async (adminId, years, apply) => {
    return await axios.post(`${BACKEND_URL}/api/admin/tenure-milestones/resolve`, { adminId, years, apply });
};

const AdminKpiRecordService = {
    getAdminKpiRecords,
    getAdminKpiRecord,
    addAdminKpiRecord,
    editAdminKpiRecord,
    deleteAdminKpiRecord,
    getAdminPointsSummary,
    generateMonthlySummary,
    getMonthlySummaries,
    updateMonthlySummaryBonus,
    setMonthlySummaryManual,
    recalculateMonthlySummary,
    markRunPaid,
    unmarkRunPaid,
    getPayrollReport,
    openVoucherPdf,
    getTenureMilestones,
    resolveTenureMilestone
};

export default AdminKpiRecordService;

